import React, { useState, useMemo } from 'react';
import { useTheme, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import CustomToggle from '../../../Components/Inputs/CustomToggle';
import {
  CenteredFlexBox,
  ColumnFlexBox,
  FullSizeColumn,
} from '../../../Components/FlexBox';
import TableWrapper from './TableWrapper';
import PivotWrapper from '../../PivotReport/PivotWrapper';
import {
  DEFAULT_SLICE_REDEMPTION_PIVOT,
  getMetadataRedemption,
} from '../../PivotReport/utils/constant';
import { compareDates } from '../../../Helpers/dates';

const filterPivotDataByMetadata = (data, metadataKeys) => {
  if (!Array.isArray(data)) return data;
  return data.map((item) =>
    Object.keys(item).reduce((acc, key) => {
      if (key in metadataKeys) {
        acc[key] = item[key];
      }
      return acc;
    }, {})
  );
};

const PivotReportWrapper = function PivotReportWrapper({
  branchRedemptionData,
  userRedemptionData,
  branchPivotData,
  userPivotData,
  isOperator,
  userRoles,
  chartView,
  isRolling,
}) {
  const theme = useTheme();
  const intl = useIntl();
  const [tab, setTab] = useState('USER');

  const handleChangeTab = (event, newTab) => {
    setTab(newTab);
  };

  const metadataKeys = useMemo(() => getMetadataRedemption(intl), [intl]);

  const filteredPivotData = useMemo(
    () =>
      filterPivotDataByMetadata(
        tab === 'USER' || isOperator ? userPivotData : branchPivotData,
        metadataKeys
      ),
    [tab, isOperator, userPivotData, branchPivotData, metadataKeys]
  );
  return (
    <FullSizeColumn overflow="hidden">
      <CenteredFlexBox justifyContent="center">
        {!isOperator && (
          <CustomToggle
            backgroundColor={
              theme.palette.mode === 'dark' ? 'greys.darker' : '#ededed'
            }
            thumbColor={theme.palette.mode === 'dark' ? '#111' : '#fff'}
            value={tab}
            handleChange={handleChangeTab}
            tabs={[
              { id: 'USER', label: 'USERS_REDEMPTION' },
              { id: 'BRANCH', label: 'BRANCHES_REDEMPTION' },
            ]}
            height="72px"
            width="40%"
            borderRadius="50px"
          />
        )}
      </CenteredFlexBox>
      <ColumnFlexBox overflow="auto" gap="24px" padding="16px">
        <TableWrapper
          data={(tab === 'USER' || isOperator
            ? userRedemptionData
            : branchRedemptionData
          )
            ?.filter(
              ({ rollingDate }) =>
                !isRolling || compareDates(new Date(rollingDate), new Date())
            )
            ?.sort((a, b) => {
              const aValue =
                a?.practices && a?.answeredNum
                  ? (a?.practices / a?.answeredNum) * 100
                  : 0;
              const bValue =
                b?.practices && b?.answeredNum
                  ? (b?.practices / b?.answeredNum) * 100
                  : 0;
              return bValue - aValue;
            })}
        />
        {isOperator ? null : (
          <Box sx={{
            minHeight: "600px"
          }}>
            <PivotWrapper
              pivotType={4}
              data={filteredPivotData}
              visible={!chartView}
              slice={DEFAULT_SLICE_REDEMPTION_PIVOT}
              getMetadata={getMetadataRedemption}
              localStorageKey="redemptionPivotConfiguration"
              userRoles={userRoles}
            />
          </Box>
        )}
      </ColumnFlexBox>
    </FullSizeColumn>
  );
};

export default PivotReportWrapper;
